import { ROOT_SERVER } from "./Static";

export function fullImageUrl(vendor, slug, file, grant) {
  if (!vendor || !slug || !file) {
    return "";
  }

  const url = `${ROOT_SERVER}${vendor}/${slug}/full/${file}`;
  if (!grant) {
    return url;
  }

  return `${url}?img=${encodeURIComponent(grant)}`;
}
